<template>
  <div class="font-geomanist leading-none">
    <slot />
  </div>
</template>
